import { get } from '../../utils/objectHelpers';
import MainComp from '../str-main/component';

export default {
    onCreate(input) {
        this.setData(input);
    },
    onInput(input) {
        this.setData(input); // Need to re-set properties when ajaxUpdate inputs new data.
    },
    setData(data) {
        const options = get(data, 'sortItemsSelection.options', []);
        const selectedOption = options.find(opt => opt.selected);
        this.state = {
            options: options,
            selectedText: selectedOption && selectedOption.text
        };
    },
    updateState(data) {
        this.state.options.forEach((option, idx) => {
            option.selected = data.checked[0] === idx;
            if (option.selected) {
                this.state.selectedText = option.text;
            }
        });
        this.setStateDirty('options');
    },
    sortListings(data) {
        const previousState = JSON.parse(JSON.stringify(this.state));
        this.updateState(data);
        const dataUrl = JSON.parse(get(data, 'el.dataset.url', ''));
        MainComp.sendSortListingsEvent({
            url: dataUrl,
            errorCallback: () => {
                // Revert the menu if error
                this.state.options = previousState.options;
                this.state.selectedText = previousState.selectedText;
                this.setStateDirty('options');
            }
        });
    }
};
